import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createProduct } from "../actions/productActions";
import { Navigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import NotAuthorized from "../components/NotAuthorized";
import "../css/records.css";
const ProductAddScreen = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [productType, setProductType] = useState("");
  const [price, setPrice] = useState(0);
  const [slashPrice, setSlashPrice] = useState(0);
  const [gst, setGst] = useState(0);
  const [withoutGST, setWithoutGST] = useState(0);
  const [inStock, setInStock] = useState(0);
  const [category, setCategory] = useState("");
  const [specs, setSpecs] = useState([]);

  const productCreate = useSelector((state) => state.createProduct);
  const { createdProduct } = productCreate;

  useEffect(() => {
    if (createdProduct) {
      // Redirect to the product details page or the product list page
      Navigate(`/product/${createProduct._id}`);
    }
  }, [createdProduct]);

  const adminInfo = useSelector((state) => state.adminInfo);
  const { adminData } = adminInfo;

  useEffect(() => {
    if (adminData) {
      if (adminData.accessLevel === "Viewer") {
        console.log("you're not allowed");
      }
    }
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      createProduct(
        name,
        description,
        productType,
        price,
        slashPrice,
        gst,
        withoutGST,
        inStock,
        category,
        specs
      )
    );
  };

  const addFields = () => {
    let newfield = {
      name: "",
      value: "",
    };

    setSpecs([...specs, newfield]);
  };

  return (
    <div className="container-fluid  ps-0">
      <div className="row ">
        <div className="col-lg-2">
          <Sidebar active={5} />
        </div>
        <div
          className="col-lg-10 p-0"
          style={{
            overflowY: "scroll",
            height: "100vh",
          }}
        >
          {adminData && adminData.accessLevel === "Viewer" ? (
            <NotAuthorized />
          ) : (
            <div className="records-page">
              <div className="records-header-row d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="records-heading">Add Product</h4>
                <button
                  className="btn btn-primary text-light records-action-btn"
                  onClick={submitHandler}
                >
                  <i class="fa-solid fa-check"></i> Add Product
                </button>
              </div>

              <div className="row">
                <div className="col-lg-6 mb-3">
                  <div className="form-card">
                    <h6 className="form-card-title">Product Info</h6>
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="product-name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Name"
                      />
                      <label for="product-name">Name</label>
                    </div>
                    <div class="form-floating mb-3">
                      <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        className="form-control"
                        style={{
                          height: "150px",
                        }}
                        placeholder="Description"
                        id="product-description"
                      ></textarea>
                      <label for="product-description">Description</label>
                    </div>
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        class="form-control"
                        id="product-tagline"
                        value={productType}
                        onChange={(e) => setProductType(e.target.value)}
                        placeholder="Tagline"
                      />
                      <label for="product-tagline">Tagline</label>
                    </div>

                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          value={price}
                          onChange={(e) => setPrice(e.target.value)}
                          id="product-price"
                          placeholder="Price"
                        />
                        <label for="product-price">Price</label>
                      </div>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          value={slashPrice}
                          onChange={(e) => setSlashPrice(e.target.value)}
                          class="form-control"
                          id="product-slash-price"
                          placeholder="Slash Price"
                        />
                        <label for="product-slash-price">Slash Price</label>
                      </div>
                    </div>

                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-gst"
                          placeholder="GST"
                          value={gst}
                          onChange={(e) => setGst(e.target.value)}
                        />
                        <label for="product-gst">GST</label>
                      </div>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-without-gst"
                          placeholder="Without GST"
                          value={withoutGST}
                          onChange={(e) => setWithoutGST(e.target.value)}
                        />
                        <label for="product-without-gst">Without GST</label>
                      </div>
                    </div>
                    <div className="d-flex" style={{ gap: "0.75em" }}>
                      <div class="form-floating mb-3 w-100">
                        <input
                          type="number"
                          class="form-control"
                          id="product-in-stock"
                          value={inStock}
                          onChange={(e) => setInStock(e.target.value)}
                          placeholder="In Stock"
                        />
                        <label for="product-in-stock">In Stock</label>
                      </div>
                      <div class="w-100">
                        <select
                          onChange={(e) => setCategory(e.target.value)}
                          class="form-select h-100"
                          aria-label="Category"
                        >
                          <option
                            value="bike"
                            selected={category === "bike" && true}
                          >
                            Bike
                          </option>
                          <option
                            value="accessorie"
                            selected={category === "accessorie" && true}
                          >
                            Accessorie
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-3">
                  <div className="form-card">
                    <h6 className="form-card-title">Product Specs</h6>
                    {specs.map((item, i) => (
                      <div key={i}>
                        <div className="d-flex" style={{ gap: "0.75em" }}>
                          <div class="form-floating mb-3 w-100">
                            <input
                              type="text"
                              class="form-control"
                              value={item.name}
                              onChange={(e) => {
                                let data = [...specs];
                                data[i].name = e.target.value;
                                setSpecs(data);
                              }}
                              id={`spec-name-${i}`}
                              placeholder="Spec"
                            />
                            <label for={`spec-name-${i}`}>Spec</label>
                          </div>
                          <div class="form-floating mb-3 w-100">
                            <input
                              type="text"
                              class="form-control"
                              value={item.value}
                              onChange={(e) => {
                                let data = [...specs];
                                data[i].value = e.target.value;
                                setSpecs(data);
                              }}
                              id={`spec-value-${i}`}
                              placeholder="Value"
                            />
                            <label for={`spec-value-${i}`}>Value</label>
                          </div>
                        </div>
                      </div>
                    ))}

                    <button
                      className="btn btn-primary records-icon-btn mx-auto d-block"
                      onClick={addFields}
                      title="Add spec"
                    >
                      <i class="fa-solid fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductAddScreen;
